import { Outlet } from "react-router-dom";

const RightSide = () => {
  return (
    <div className="w-1/2">
      <div className="w-full flex justify-end">
        <img
          className="h-48"
          src="/login-right-side-logo.svg"
          alt="ADQUIVER MEDIA"
        />
      </div>
      <div className="px-[30%] py-[10%]">
        <Outlet />
      </div>
    </div>
  );
};

export default RightSide;